import React from 'react';
import './FormattedJsonViewer.css';
import FormattedSection from './FormattedSection';

const FormattedArray = (props) => {

    return (
        <div>
                {props.data.map((element, index) => {

                    let title = index === 0 ? props.title + ":" : "";

                    return(<div>
                        <FormattedSection data={element.ChildItems} title={title} index={index} titleWidth={props.titleWidth}></FormattedSection>
                    </div>);
                })}

        </div>
    );
};
  
export default FormattedArray;